module.exports = __webpack_public_path__ + "home_s2_3.png?ce05277f37638feb66b9718177dd5798";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home_s2_3.png
// module id = 6
// module chunks = 0